import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { Sport, SportSlug } from '../types/landing';
import { ContentNote } from './ContentNote';
import { SectionHeading } from './SectionHeading';
interface ExploreMoreProps {
  heading: string;
  cityName: string;
  citySlug: string;
  sports: Sport[];
  onSelectSport: (slug: SportSlug) => void;
  onOpenMetro?: () => void;
  showNote?: boolean;
}
export function ExploreMore({
  heading,
  cityName,
  citySlug,
  sports,
  onSelectSport,
  onOpenMetro,
  showNote = true
}: ExploreMoreProps) {
  return <section aria-labelledby="explore-heading" className="relative px-5 py-12 md:px-10 md:py-16" data-id="element-15" data-mp="2qj5ygo1ccm8a">
      <SectionHeading id="explore-heading" data-id="element-16" data-mp="35c93xx1nr9in">{heading}</SectionHeading>
      <ul className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-17" data-mp="30ceelxxj6rzp">
        {sports.map(s => {
        const url = `/${citySlug}/${s.slug}`;
        return <li key={s.slug} data-id="element-18" data-mp="39brm4l23h6hs">
              <a href={url} onClick={e => {
            e.preventDefault();
            onSelectSport(s.slug);
          }} className="group flex h-full flex-col border border-brand-line bg-white transition-colors duration-150 hover:border-brand-sky" data-id="element-19" data-mp="39ct130m8ed4s">
                <div className="h-40 overflow-hidden" data-id="element-20" data-mp="1b178g40204l7">
                  <img src={s.heroImage} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-21" data-mp="1b3tfm2j18i2w" />
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-22" data-mp="1k1vot5cx6h19">
                  <h3 className="font-display text-2xl font-bold uppercase leading-tight text-brand-navy" data-id="element-23" data-mp="1p0zvnpcdg2of">{s.name} in {cityName}</h3>
                  <p className="mt-1 text-sm text-brand-muted" data-id="element-24" data-mp="1ttj8ul75cvsp">{s.exploreBlurb}</p>
                  <span className="mt-auto inline-flex items-center gap-1.5 pt-4 text-sm font-semibold text-brand-red" data-id="element-25" data-mp="1yq9oj7f1hpdl">
                    Explore {s.noun} <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-26" data-mp="23s8pybr7yc7w" />
                  </span>
                </div>
              </a>
            </li>;
      })}
        {onOpenMetro && <li data-id="element-27" data-mp="8l547tl5s0g7">
            <a href={`/${citySlug}`} onClick={e => {
          e.preventDefault();
          onOpenMetro();
        }} className="flex h-full min-h-[260px] flex-col bg-brand-navy p-6 text-white transition-colors duration-150 hover:bg-brand-navyDark" data-id="element-28" data-mp="3o4wle8nupmz">
              <h3 className="font-display text-[32px] font-bold uppercase italic leading-[0.95]" data-id="element-29" data-mp="cmqagw36tghf">All Youth Sports in {cityName}</h3>
              <p className="mt-3 text-sm text-white/85" data-id="element-30" data-mp="mewbevbf388r">Flag football, soccer, basketball, baseball, volleyball and more, for ages 3 and up.</p>
              <span className="mt-auto inline-flex items-center gap-1.5 pt-4 text-sm font-semibold" data-id="element-31" data-mp="10dvpj91b04qo">
                Back to {cityName} Youth Sports <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="wazgoa1kfmzx" />
              </span>
            </a>
          </li>}
      </ul>
      {showNote && <ContentNote kind="hybrid" detail="Built from sports offered in metro. Last card → Metro page." data-id="element-33" data-mp="2y5i764cyeemy" />}
    </section>;
}